import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { RootState } from "store";

const getState = (state: RootState) => state;

const getBookButtonChannel = createSelector(
  getState,
  state => state.bookButton,
);

export const getBookDrawerState = createSelector(
  getBookButtonChannel,
  ({ bookId, referrerUserId }) => {
    return {
      bookId,
      referrerUserId,
      isOpen: bookId !== null,
    };
  },
);

export const getActiveBookId = createSelector(
  getBookButtonChannel,
  ({ bookId }) => bookId,
);

export const getBookButtonBootstrapped = createSelector(
  getBookButtonChannel,
  ({ isLoaded }) => {
    return isLoaded;
  },
);

// Get the currently logged in user's book
export const getUserBookStatus = (bookId: number) =>
  createSelector(
    getBookButtonChannel,
    ({ userBookStatusMap }): number | null => {
      return userBookStatusMap ? userBookStatusMap[bookId] || null : undefined;
    },
  );
export function useUserBookStatus(bookId: number): number {
  return useSelector(getUserBookStatus(bookId));
}

export const getIsUserBookStatusLoaded = () =>
  createSelector(getBookButtonChannel, ({ userBookStatusMap }): boolean => {
    return userBookStatusMap !== undefined;
  });
export function useIsUserBookStatusLoaded(): boolean {
  return useSelector(getIsUserBookStatusLoaded());
}

export const getUserBookStatusMap = () =>
  createSelector(getBookButtonChannel, ({ userBookStatusMap }) => {
    return userBookStatusMap;
  });
export function useUserBookStatusMap(): Record<number, number> | null {
  return useSelector(getUserBookStatusMap());
}
